module.exports = __webpack_public_path__ + "static/media/line-chart.68ef08f5.svg";